<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="local"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    [label]="'DOCUMENTS_REVIEW.LIST.PENDING_REVIEW' | translate"
    [data]="widgetData"
    [showData]="loadedData || isStoreView"
  ></app-widget-principal-data>

</app-widget-home-core>
